// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectOrder_custom-select__6KtHW","header-select":"SelectOrder_header-select__zZsj6"};